import { render, staticRenderFns } from "./Tweet.vue?vue&type=template&id=b3ecf2b4&scoped=true&"
import script from "./Tweet.vue?vue&type=script&lang=js&"
export * from "./Tweet.vue?vue&type=script&lang=js&"
import style0 from "./Tweet.vue?vue&type=style&index=0&id=b3ecf2b4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3ecf2b4",
  null
  
)

export default component.exports